<template>
  <div class="mt-20">
    <nav class="panel bloc-actions-modal">
      <a class="panel-block block-top">
        <div class="level is-width-100p" v-if="getNbrSelect">
          <div class="level-left is-marginless">
            <p class="has-text-default is-size-10px">
              Total de ma sélection
            </p>
          </div>
            <div class="level-right is-marginless">
              <p class=" ml-10">
                <strong class="has-text-grid-1 is-size-14px">
                  {{solde}}
                </strong>
                <label class="has-text-default is-size-10px">HT</label>
              </p>
            </div>
        </div>
        <p class="has-text-centered is-width-100p has-text-default is-size-14px" v-else>
          Aucun produit sélectionné
        </p>
      </a>
      <a class="panel-block no-boder-x" @click="showModal('MailRecom')">
        <p class="has-text-centered is-width-100p has-text-default is-size-14px">
          Demander des modifications
        </p>
      </a>
      <a class="panel-block no-boder-x" @click="showModal('RefuRecom')">
        <p class="has-text-centered is-width-100p has-text-default is-size-14px">
          Refuser la recommandation
        </p>
      </a>
      <a class="panel-block block-bottom has-background-grid-5">
        <b-button
          icon-left="check-circle"
          type="is-grid-5"
          expanded
          @click="showModal('ValidRecom'), validRecom = true">
          <span class="is-size-14px has-text-weight-bold">
            Valider la recommandation
          </span>
        </b-button>
      </a>
    </nav>
    <b-modal :active.sync="isModalActive" :width="640" scroll="keep">
      <div class="card pa-20 radius-10">
        <component
          :is="component"
          @close="isModalActive = false"
          @modif="component = 'MailRecom'"
          :valid="validRecom"/>
      </div>
    </b-modal>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import { formatNombre } from '@/services/general/general';
import RefuRecom from './actionsModal/RefuRecom';
import MailRecom from './actionsModal/MailRecom';
import ValidRecom from './actionsModal/ValidRecom';

const Recommandation = createNamespacedHelpers('recommandation');

export default {
  components: {
    RefuRecom,
    MailRecom,
    ValidRecom,
  },
  data: () => ({
    isModalActive: false,
    component: '',
    validRecom: false,
  }),
  computed: {
    ...Recommandation.mapGetters([
      'getSolde',
      'getNbrSelect',
    ]),
    solde() {
      return formatNombre(this.getSolde);
    },
  },
  methods: {
    showModal(type) {
      this.component = type;
      this.isModalActive = true;
    },
  },
};
</script>

<style>

</style>